export default {
    inc: {
        loading: {
            load  : "Das Ereignis wird geladen ...",
            create: "Das Ereignis wird erstellt ...",
        },

        change: {
            title  : "Neue Ereignisart",
            confirm: "Soll die Ereignisart von <b>{0}</b> nach <b>{1}</b> geändert werden?"
        },

        confirm: {
            document: {
                detach: {
                    query: "Dokument vom Ereignis lösen?",
                    text: "Mit JA wird das Dokument von dem aktuell angezeigten Ereignis gelöst. Das Dokument wird anschließend wieder in der INBOX angezeigt und kann erneute einem Ereignis zugeordnet werden."
                },
                delete: {
                    query: "Dokument löschen?",
                    text: "Mit JA wird das Dokument unwideruflich gelöscht. Das Dokument kann anschließend jedoch wieder eneut importiert werden."
                },
            }
        },

        rules: {
            component: "Austausch oder Reparatur angeben"
        },

        components: {
            actions: {
                UNDEFINED: "",
                REPAIR   : "(Reparatur)",
                CHANGE   : "(Austausch)"
            },
            label: {
                "1": "Komponenten des Aufzugs",
                "2": "Komponenten der Fahrtreppe"
            }
        },

        company: {
            exe: "Ausf. Unternehmen",
        },

        unit: {
            elevatorNo: "Fabrik-Nr.",
            remove: {
                query: "Anlage aus der Ereignismappe entfernen?",
                text : "Mit <b>JA</b> wird die Anlage aus der Ereignismappe entfernt. Es werden dabei alle Daten zu der Anlage in der Ereignismappe unwideruflich gelöscht. Soll die Anlage wirklich entfernt werden?"
            }
        },

        delete: {
            tooltip: "Ereignismappe löschen",
            confirm: {
                query: "Ereignismappe löschen",
                text : "Die Löschung kann innerhalb der nächsten 4 Wochen mit entsprechenden Rechten wieder rückgängig gemacht werden. Mit <b>JA</b> wird die Ereignismappe gelöscht."
            }
        },

        undelete: {
            tooltip: "Ereignismappe wieder herstellen",
            confirm: {
                query: "Ereignismappe wieder herstellen",
                text : "Mit <b>JA</b> wird die Ereignismappe wieder hergestellt."
            }
        },

        attach: {
            overwrite: {
                query: "<span style='color:red'>Daten überschreiben?</span>",
                text : "Durch das Anhängen des Dokuments aus der Inbox werden Daten des Ereignis im Dialog überschrieben?<p style='margin-top:8px; margin-bottom: 0'>Mit <b>JA</b> wird das Dokument an das Ereignis <b>angehängt</b> und die Daten im Dialog <b>überschrieben</b>.</p><p style='margin-top:8px; margin-bottom: 0'>Mit <b>NEIN</b> wird das Dokument an das Ereignis <b>angehängt</b>, die Daten im Dialog aber <b>nicht überschrieben</b>.</p><p style='margin-top:8px; margin-bottom: 0'>Mit <b>ABBRECHEN</b> wird das Dokument <b>nicht angehängt</b>.</p>"
            }
        },

        overview: {
            header: {
                state    : "S",
                begin    : "Beginn",
                end      : "Ende",
                type     : "Ereignisart",
                status   : "Status",
                user     : "Bearbeiter",
                id       : "HC-ID / E-ID",
                fabricNo : "Fabrik-Nr.",
                siteId   : "ID Anlage",
                street   : "Straße",
                city     : "PLZ Ort",
            },
            menu: {
                export   : "Daten exportieren",
                refresh  : "Anzeige aktualisieren",
                filteroff: "Gelöschte Einträge werden nicht anzeigt",
                filteron : "Gelöschte Einträge werden anzeigt"
            },
        },

        assessment: {
            company : "ZÜS",
            date    : "Prüfungsdatum",
            type    : "Art der Prüfung",
            result  : "Ergebnis",
            addFault: "Mängelliste erweitern",
            error: {
                faultsMax: "Das Prüfungsergebnis ist <b>{0}</b>, die Mängeliste enthält aber auch <b>{1}e Mängel</b>",
                faultsMin: "Das Prüfungsergebnis ist <b>{0}</b>, die Mängeliste enthält aber nur <b>{1}e Mängel</b>",
                faultsNotice: "Das Prüfungsergebnis ist <b>{0}</b>, die Mängeliste enthält aber nur <b>Notizen</b>",
                nextDates: "Nächste Prüfung vor Nachprüfung"
            },
            postponment: {
                currentDate: "Bisheriges Prüfungsdatum",
                newDate    : "Neues Prüfungsdatum",
                received   : "Emfangen am",
                reporter   : "gemelden von",
                reason     : "Grund der Verschiebung",
                comment    : "Kommentar"
            }
        },

        maintenance: {
            exedate: "Leistungsdatum",
        },

        edit: {
            menu: {
                save    : "Änderungen speichern",
                email   : "Email senden",
                history : "Historie anzeigen",
                reload  : "Ereingis neu laden",
                change  : "Ereignistyp ändern",
            },
            common: {
                executionDate: "Vorausichtliches Ausführungsdatum",
                invoice      : "Rechnung",
                processing: {
                    start: "Ereignisdatum",
                    begin: "Bearbeitung von",
                    end  : "Tatsächliches Ausführungsdatum",
                    error: "Ende vor Ereignisdatum",
                },
                sitedown : {
                    start: "Stillstand von",
                    end  : "bis",
                    error: "Stillstandsende vor Stillstandsbeginn",
                },
                unitdown : {
                    start: "Stillstand von",
                    end  : "bis",
                    error: "Stillstandsende vor Stillstandsbeginn",
                },
            },

            general: {
                reporter   : "Gemeldet von",
                external   : "Externe ID",
                offerDate  : "Angebotsdatum",
                description: "Beschreibung",
                cause      : "Ursache",
                measure    : "Maßnahme"
            },

            invoice: {
                warranty     : "Gewährleistung",
                warrantyDate : "bis",
                allComponents: "alle Komponenten"
            }
        },


        stamper: {
            text  : "Stempel Texte",
            first : "1. Zeile",
            second: "2. Zeile",
            save  : "Übernehmen",
            stamp : "Stempeln"
        },

        docexport: {
            interval: {
                from : "Von",
                to   : "Bis"
            }
        },

        missing: {
            description: "Beschreibung",
            measure    : "Maßnahme",
            unitdownend: "Stillstand bis",
            bidnumber  : "Angebotsnummer",
            enddate    : "Bearbeitungsende",
            bidmeassure: "Angebot Maßnahme",
            bidprice   : "Angebotspreis",
            components : "Komponenten"
        }
    },

    main: {
        inc: {
            errors: {
                assessment: {
                }
            },

            hints: {
                assessment: {
                    exists: {
                        title  : "Die Einplanung für die ZÜS Prüfung wurde erstellt",
                        message: "Für die Anlage mit der Fabriknummer {0} existiert bereits eine geplante {1}.",
                        action : "Prüfung anzeigen"
                    }
                }
            },
            notice: "Notizen zum Ereignis",
        },
    },

    journal: {
        document: {
            create : "Dokument erstellt",
            delete : "Dokument gelöscht",
            replace: "Dokument ersetzt",
            version: "Version wieder hergestellt",
            combine: "Dokument zusammengefasst"
        }
    }
}